module.exports = __webpack_public_path__ + "img/order-tab-delivered-active.322f55c6.png";